import React from 'react';
import { DateTime } from 'luxon';
import { TDR } from 'tdr-common';
import { cn } from '@/lib/utils';
import { getParameterTimes } from '../../../helpers/open-parameters/defaultParameterTimes';
import {
	desktopPickerOptionBaseClassName,
	desktopPickerOptionSelectedClassName,
	desktopPickerScrollAreaClassName,
	desktopPickerTimeOptionClassName
} from './desktopParameterPickerStyles';
import { analytics, FILTER_CHANGED } from '../../../helpers/analytics';
import { useFilterAnalytics } from '../../../helpers/analytics/filterContext';

export interface DesktopOpenTimeSelectorProps {
	restaurant: TDR.Restaurant;
	value?: string;
	onChange: (time: string) => void;
}

const getDisplayParts = (hhmm: string) => {
	const dt = DateTime.fromFormat(hhmm, 'HH:mm');
	return { time: dt.toFormat('h:mm'), ampm: dt.toFormat('a').toUpperCase() };
};

export const DesktopOpenTimeSelector = ({ restaurant, value, onChange }: DesktopOpenTimeSelectorProps) => {
	const times = getParameterTimes(restaurant);
	const filterCtx = useFilterAnalytics('global explore');
	return (
		<div className={cn('grid grid-cols-2 gap-x-3 gap-y-4', desktopPickerScrollAreaClassName)}>
			{times.map(time => {
				const isSelected = time === value;
				const { time: timeLabel, ampm } = getDisplayParts(time);
				return (
					<button
						key={time}
						type="button"
						onClick={() => {
							analytics.track(FILTER_CHANGED, {
								filterName: 'time',
								filterValue: time,
								source: 'open_parameters_time',
								...filterCtx
							});
							onChange(time);
						}}
						className={cn(
							desktopPickerOptionBaseClassName,
							desktopPickerTimeOptionClassName,
							'gap-1',
							isSelected && desktopPickerOptionSelectedClassName
						)}
					>
						<span>{timeLabel}</span>
						<span className="font-normal text-white/30">{ampm}</span>
					</button>
				);
			})}
		</div>
	);
};
